var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemBalanceRequestsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.639,
    height: 19.172,
    viewBox: "0 0 20.639 19.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M6.74,5.383H2.692A2.691,2.691,0,1,1,2.692,0H6.74",
    transform: "translate(12.398 6.013)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M.612.456H.3",
    transform: "translate(14.937 8.187)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M5.248,0h8.643a5.248,5.248,0,0,1,5.248,5.248v7.177a5.248,5.248,0,0,1-5.248,5.248H5.248A5.248,5.248,0,0,1,0,12.425V5.248A5.248,5.248,0,0,1,5.248,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M0,.456H5.4",
    transform: "translate(4.536 4.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemBalanceRequestsIcon);
export default __webpack_public_path__ + "static/media/menu-item-balance-requests-icon.d9066790901daec6f0690c50ba7969dc.svg";
export { ForwardRef as ReactComponent };